import { type SummarySlice } from "./state";

export const initialState: SummarySlice = {
  summary: null,
  isPending: false,
  isRejected: false,
  errorMessage: "",
};
